import { render, staticRenderFns } from "./formatter.vue?vue&type=template&id=48205efc&"
import script from "./formatter.vue?vue&type=script&lang=js&"
export * from "./formatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports